import { themedImages, type ThemedImageName } from './themedImages';
import { useResolvedTheme } from './useResolvedTheme';

/**
 * The single place that decides which themed SVG variant (light/dark) to use.
 * Returns the resolved image URL string for `name`, ready to pass to
 * `next/image` (`ThemedImage` uses this) or to any component whose `src`/icon
 * prop expects an image source (e.g. honeypot-ui's `NavigationItem`).
 *
 * The light/dark decision is driven entirely by the theme class on the document
 * root, which `_app` owns via `applyThemeClass`. That single gate means when the
 * theming feature is disabled the root is forced to `.light`, so this returns
 * the light variant — no separate feature-flag check is needed here.
 */
export function useThemedImageSource(name: ThemedImageName): string {
  const resolvedTheme = useResolvedTheme();
  return themedImages[name][resolvedTheme];
}
